import { render, staticRenderFns } from "./ShiftSummaryHeader.vue?vue&type=template&id=77dffb06&lang=pug"
import script from "./ShiftSummaryHeader.vue?vue&type=script&lang=js"
export * from "./ShiftSummaryHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports